// Backported from OLD sg and refactored so it works with the old and the new navigation. (for the feature flag)

// we have to use the legacy Panel class because the new one is not compatible with the old navigation (until the whole panels are migreated).
import { Panel } from '@phx-styleguides/core';

import { lazySelector } from '@sg-core/resources/assets/js/utils/dom';
import { mergeDeep } from '@sg-core/resources/assets/js/utils/object';

export class SearchPanel extends Panel {
  #navbar: HTMLElement | null = null;
  #panelBody: HTMLElement | null = null;
  #panelOverlay: HTMLElement | null = null;
  #resizeObserver: ResizeObserver | null = null;

  constructor(el: string | HTMLElement, { onShow, ...otherOptions }: { onShow?: () => void } = {}) {
    super(
      el,
      mergeDeep(
        {
          onShow: () => {
            this.#updateTopPosition();
            onShow?.();
          },
        },
        otherOptions,
      ),
    );

    this.#navbar =
      document.querySelector<HTMLElement>('.phxsg-navigation') || document.querySelector('#topbar') || null;
    const element = lazySelector(el);
    this.#panelBody = element?.querySelector('.panel-body') || null;
    this.#panelOverlay = element?.querySelector('.panel-overlay') || null;

    if (this.#navbar) {
      this.#setupPositionObserver();
    }

    this.#updateTopPosition();
  }

  #setupPositionObserver() {
    this.#resizeObserver = new ResizeObserver(() => {
      this.#updateTopPosition();
    });

    this.#resizeObserver.observe(document.body);

    const banners = document.querySelectorAll('.phxsg-promo-banner, .promo-banner');
    banners.forEach((banner) => {
      this.#resizeObserver?.observe(banner as HTMLElement);
    });
  }

  #updateTopPosition() {
    if (!this.#navbar) return;

    const top = this.#navbar.getBoundingClientRect().top;
    const bottom = this.#navbar.getBoundingClientRect().bottom;
    if (this.#panelBody) {
      this.#panelBody.style.top = `${top}px`;
    }
    if (this.#panelOverlay) {
      this.#panelOverlay.style.top = `${bottom}px`;
    }
  }

  destroy() {
    this.#resizeObserver?.disconnect();
  }
}
